<template>
  <b-container fluid>
    <div class="iq-card mt-3 px-3">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title py-3">
          <h4 class="card-title">Event</h4>
        </div>

        <div class="text-right">
          <button-options :access="'master_events'" :hideAdd="false" :hideDetail="true" :isRefreshEnabled="true"
            :isRefreshed="isRefreshed" @onAddItemClicked="openAddForm" @onRefreshed="getData('Refreshed')" />
        </div>
      </div>
      <div class="iq-card-body">
        <div class="d-flex mb-1">
          <input class="form-control" type="text" placeholder="Search Event" v-model="filter.mevtType"
            style="width: 300px; margin-right: 10px">

          <b-form-select v-model="filter.mevtIsPriority" style="width: 200px; margin-right: 10px">
            <template v-slot:first>
              <option value=''>All Priority</option>
            </template>
            <option value="1">High</option>
            <option value="0">Normal</option>
          </b-form-select>

          <button class="btn btn-primary" @click="applyFilter">Apply</button>
        </div>
        <b-table striped hover head-variant="dark" show-empty :busy="isLoading" :fields="fields" responsive
          :items="canRead('master_events') ? data : []" style="border-radius: 10px;">
          <template v-slot:table-busy="">
            <div class="text-center text-danger my-2">
              <b-spinner variant="success" size="sm" class="align-middle"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(matyCreatedTime)="data">
            {{ dateWithDDMMYYYYFormat(data.value) }}
          </template>

          <template v-slot:cell(mevtIsPriority)="data">
            <div class="d-flex justify-content-center">
              <b-badge v-if="data.value == 0" variant="success">Normal</b-badge>
              <b-badge v-else variant="danger">High</b-badge>
            </div>
          </template>

          <template v-slot:cell(action)="data">
            <div class="text-center">
              <button-options :access="'master_events'" :hideAdd="true" :hideDelete="false" :hideDetail="true"
                :hideEdit="false" @onDeleteClicked="openDelete(data.item)" @onEditClicked="openEdit(data.item)"
                @onViewClicked="openDetail(data.item)" />
            </div>
          </template>

        </b-table>
        <b-pagination v-model="pagination.current" :per-page="pagination.pageSize" :total-rows="pagination.totalSize"
          @change="onPageChanged"></b-pagination>
      </div>
      <b-modal size="lg" hide-footer no-close-on-esc no-close-on-backdrop v-model="displayForm">
        <!-- Start Form -->
        <div class="iq-card mb-0" style="min-width: 300px;">
          <div class="iq-card-header d-flex justify-content-between">
            <div class="iq-header-title">
              <h4 class="card-title">{{ current.mevtId ? 'Edit Event' : 'Add Event' }}</h4>
            </div>
          </div>
          <div class="iq-card-body">
            <div class="row">
              <!-- event type input -->
              <div role="group" class="form-group mb-3 col-md-6">
                <label for="mevtType" class="d-block form-label text-left">
                  Event Type:
                </label>

                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <input class="form-control" type="text" id="mevtType" placeholder="Event Type"
                      v-model="current.mevtType" :class="errors.mevtType ? 'is-invalid' : ''">
                    <b-form-invalid-feedback v-if="errors.mevtType">
                      {{ Object.values(errors.mevtType) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
              <!-- end event type input -->

              <!-- event trigger duration input -->
              <div role="group" class="form-group mb-3 col-md-6">
                <label for="mevtTriggerDuration" class="d-block form-label text-left">
                  Event Trigger Duration:
                </label>

                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <input class="form-control" type="text" id="mevtTriggerDuration"
                      placeholder="Event Trigger Duration" v-model="current.mevtTriggerDuration"
                      :class="errors.mevtTriggerDuration ? 'is-invalid' : ''">
                    <b-form-invalid-feedback v-if="errors.mevtTriggerDuration">
                      {{ Object.values(errors.mevtTriggerDuration) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
              <!-- end event trigger duration input -->

              <div role="group" class="form-group mb-3 col-md-6">
                <label for="mevtTriggerDuration" class="d-block form-label text-left">
                  Priority
                </label>

                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <select class="form-control" v-model="current.mevtIsPriority">
                      <option value="1">High</option>
                      <option value="0">Normal</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- event trigger description input -->
              <div role="group" class="form-group mb-3 col-md-6">
                <label for="mevtDescription" class="d-block form-label text-left">
                  Event Trigger Description:
                </label>

                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <textarea class="form-control" id="mevtTriggerDescription" placeholder="Event Trigger Description"
                      v-model="current.mevtDescription"
                      :class="errors.mevtTriggerDescription ? 'is-invalid' : ''"></textarea>
                    <b-form-invalid-feedback v-if="errors.mevtDescription">
                      {{ Object.values(errors.mevtDescription) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
            </div>
            <!-- end event trigger description input -->
            <div class="row" v-for="(_device, index) in current.thresholdDevice" :key="index">
              <div role="group" class="form-group mb-3 col-md-4">
                <label class="d-block form-label text-left">
                  Device Name
                </label>
                <div role="group" class="input-group">
                  <input class="form-control" type="text" placeholder="Event Trigger Duration"
                    v-model="current.thresholdDevice[index]">
                </div>
              </div>

              <div role="group" class="form-group mb-3 col-md-3">
                <label class="d-block form-label text-left">
                  Operator
                </label>
                <div role="group" class="input-group">
                  <select class="form-control" v-model="current.deviceConditionOperator[index]">
                    <option value="and">AND</option>
                    <option value="or">OR</option>
                  </select>
                </div>
              </div>

              <div role="group" class="form-group mb-3 col-md-2">
                <label class="d-block form-label text-left">&nbsp;</label>
                <button class="btn btn-outline-primary btn-block" @click="addData(index)">Add Data</button>
              </div>

              <div role="group" class="form-group mb-3 col-md-3">
                <label class="d-block form-label text-left">&nbsp;</label>
                <button class="btn btn-outline-danger btn-block" @click="removeDeviceCondition(index)">Remove
                  Device</button>
              </div>

              <div class="mb-3 col-md-12">
                <div class="row" v-for="(_threshold, dataIndex) of current.dataKeys[index]" :key="dataIndex">
                  <div role="group" class="form-group mb-3 col-md-5">
                    <label class="d-block form-label text-left">
                      Data Key
                    </label>
                    <div role="group" class="input-group">
                      <input class="form-control" type="text" placeholder="Data Key"
                        v-model="current.dataKeys[index][dataIndex]">
                    </div>
                  </div>

                  <div role="group" class="form-group mb-3 col-md-3">
                    <label class="d-block form-label text-left">
                      Operator
                    </label>
                    <div role="group" class="input-group">
                      <select class="form-control" v-model="current.dataValues[index][dataIndex].operator">
                        <option value="==">==</option>
                        <option value="!=">!=</option>
                        <option value=">">&gt;</option>
                        <option value="<">&lt;</option>
                        <option value=">=">&gt;=</option>
                        <option value="<=">&lt;=</option>
                      </select>
                    </div>
                  </div>

                  <div role="group" class="form-group mb-3 col-md-3">
                    <label class="d-block form-label text-left">
                      Value {{ _threshold.value }}
                    </label>
                    <div role="group" class="input-group">
                      <input class="form-control" type="text" placeholder="Data Value"
                        v-model="current.dataValues[index][dataIndex].value">
                    </div>
                  </div>

                  <div role="group" class="form-group mb-3 col-md-1">
                    <label class="d-block form-label text-left">&nbsp;</label>
                    <button class="btn btn-danger btn-block text-center" @click="removeData(index, dataIndex)">
                      <i class="ri-close-fill"></i>
                    </button>
                  </div>
                </div>
              </div>

              <hr class="w-100 mx-3 mt-0" style="border-width: 2px;" />
            </div>

            <div class="form-group mb-3">
              <b-button class="mr-1" size="sm" :disabled="isSubmit" variant="outline-primary"
                @click="addDeviceCondition">
                <div class="mx-2">Add Device Condition</div>
              </b-button>
            </div>

            <div class="form-group">
              <b-button @click="onCancel" class="mr-1" size="sm" :disabled="isSubmit" variant="outline-danger">
                <div class="mx-2">Cancel</div>
              </b-button>
              <b-button type="submit" @click="onSubmitClicked(current)" :disabled="isSubmit" variant="primary" size="sm"
                class="ml-1">
                <div class="mx-2">
                  <i v-if="isSubmit" class="ri-loader-line"></i>
                  Submit
                </div>
              </b-button>
            </div>

          </div>
        </div>
        <!-- End Form -->
      </b-modal>
      <b-modal size="lg" hide-footer no-close-on-esc no-close-on-backdrop v-model="displayDeletion">
        <delete-item :isSubmit="isSubmit" @onCancelDeletion="displayDeletion = false"
          @onConfirmDeletion="onConfirmDeletion" />
      </b-modal>
    </div>
  </b-container>
</template>

<script>

import DeleteItem from '@/components/directives/delete-item';
import ButtonOptions from '@/components/directives/button-options';
import EventSvc from '@/services/EventSvc';

import requestBuilder from '@/util/master/request.builder';

export default {
  name: 'MasterEvent',
  components: {
    DeleteItem, ButtonOptions,
  },
  data() {
    return {
      current: {},
      data: [],
      displayDeletion: false,
      displayForm: false,
      errors: {},
      filter: {
        mevtType: undefined,
        mevtIsPriority: '',
      },
      isLoading: false,
      isRefreshed: false,
      isSubmit: false,
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 0,
      },
      fields: [
        {
          key: 'mevtType',
          label: 'Event Type',
          class: 'text-left',
        },
        {
          key: 'mevtTriggerDuration',
          label: 'Trigger Duration (Sec.)',
          class: 'text-left',
        },
        {
          key: 'mevtIsPriority',
          label: 'Priority',
          class: 'text-left',
        },
        {
          key: 'mevtDescription',
          label: 'Description',
          class: 'text-left',
        },
        {
          key: 'action',
          label: '',
          class: 'text-left',
        },
      ],
    };
  },
  methods: {
    async deleteData(notification, data) {
      this.isSubmit = true;
      try {
        const deleteResponse = await EventSvc.delete(data.mevtId);
        if (deleteResponse.status.error === 0) {
          this.$toast.success(notification);
          this.displayDeletion = false;
          this.pagination.current = 1;
          this.getData();
        } else {
          this.$toast.error(deleteResponse.status.message);
        }
      } catch (e) {
        this.$toast.error(e.message);
      } finally {
        this.isSubmit = false;
      }
    },
    async getData(notification) {
      try {
        if (this.filter.mevtIsPriority === '') {
          delete this.filter.mevtIsPriority;
        }

        this.isLoading = true;
        this.isRefreshed = true;
        const Response = await EventSvc.get({
          ...requestBuilder.buildFilters(this.pagination, this.filter),
        });

        const Data = Response.data;

        this.data = Data || [];

        this.pagination.totalSize = Response.pagination?.totalData || 0;
        if (notification) {
          this.$toast.success(notification);
        }
      } catch (e) {
        console.error('get data error : ', e);
        this.$toast.error('Something Wrong');
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    onCancel() {
      this.current = {};
      this.displayForm = false;
    },
    onConfirmDeletion() {
      this.deleteData('Event Deleted', this.selected);
    },
    onPageChanged(page) {
      this.pagination.current = page;
      this.getData();
    },
    onUpdated() {
      this.getData('Updated');
    },
    async onSubmitClicked(form) {
      try {
        this.errors = {};
        this.isSubmit = true;
        const mevtThresholds = {};

        form.thresholdDevice.forEach((deviceName, index) => {
          mevtThresholds[deviceName] = {};

          mevtThresholds[deviceName].conditions_operator = form.deviceConditionOperator[index];
          mevtThresholds[deviceName].data = {};

          form.dataKeys[index].forEach((dataKey, dataIndex) => {
            mevtThresholds[deviceName].data[dataKey] = form.dataValues[index][dataIndex];
          });
        });

        const data = {
          mevtType: form.mevtType,
          mevtTriggerDuration: form.mevtTriggerDuration,
          mevtIsPriority: form.mevtIsPriority,
          mevtDescription: form.mevtDescription,
          mevtThresholds: JSON.stringify(mevtThresholds),
        };

        if (!form.mevtId) { // jika tidak ada mevtId maka create
          const createResponse = await EventSvc.create(data);

          if (createResponse.status.error === 0) {
            await this.getData('Success');
            this.current = {};
          } else {
            this.$toast.error('Error when saving data');
          }
        } else { // jika ada mevtId maka update
          const updateResponse = await EventSvc.update(form.mevtId, data);
          console.debug('updateResponse : ', updateResponse);

          if (updateResponse.status.error === 0) {
            await this.getData('Success');
            this.current = {};
          } else {
            this.$toast.error('Error when Update data');
          }
        }
      } catch (e) {
        console.error('onSubmitClicked error : ', e);
        this.$toast.error('Error When Submiting Form');
      } finally {
        this.displayForm = false;
        this.isSubmit = false;
      }
    },
    openAddForm() {
      this.current = {
        mevtType: '',
        mevtTriggerDuration: '',
        mevtIsPriority: 0,
        mevtDescription: '',
        thresholdDevice: [],
        deviceConditionOperator: [],
        dataKeys: [],
        dataValues: [],
      };
      this.displayForm = true;
    },
    openDelete(data) {
      this.displayDeletion = true;
      this.selected = data;
    },
    openDetail(data) {
      this.$router.push({ name: 'UserDetail', params: { id: data.userId } });
    },
    openEdit(data) {
      console.log('open edit', data);
      this.displayForm = true;
      const currentData = { ...this._.find(this.data, (v) => v.mevtId === data.mevtId) };
      const thresholdDevice = Object.keys(JSON.parse(currentData.mevtThresholds));
      const deviceConditionOperator = Object.values(JSON.parse(currentData.mevtThresholds))
        .map((o) => o.conditions_operator || 'and');
      const dataKeys = Object.values(JSON.parse(currentData.mevtThresholds)).map((o) => Object.keys(o.data));
      const dataValues = Object.values(JSON.parse(currentData.mevtThresholds)).map((o) => Object.values(o.data));

      this.current = {
        ...currentData,
        mevtThresholds: JSON.parse(currentData.mevtThresholds),
        thresholdDevice,
        deviceConditionOperator,
        dataKeys,
        dataValues,
      };
    },
    addDeviceCondition() {
      console.log('addDeviceCondition cuy', this.current);
      if (!this.current.thresholdDevice) {
        this.current.thresholdDevice = [];
      }
      if (!this.current.deviceConditionOperator) {
        this.current.deviceConditionOperator = [];
      }
      if (!this.current.dataKeys) {
        this.current.dataKeys = [];
      }
      if (!this.current.dataValues) {
        this.current.dataValues = [];
      }

      this.current.thresholdDevice.push('NewDevice');
      this.current.deviceConditionOperator.push('and');
      this.current.dataKeys.push([]);
      this.current.dataValues.push([]);
    },
    removeDeviceCondition(index) {
      this.current.thresholdDevice.splice(index, 1);
      this.current.deviceConditionOperator.splice(index, 1);
      this.current.dataKeys.splice(index, 1);
      this.current.dataValues.splice(index, 1);
    },
    addData(index) {
      if (!this.current.dataKeys[index]) {
        this.current.dataKeys[index] = [];
      }
      if (!this.current.dataValues[index]) {
        this.current.dataValues[index] = [];
      }

      this.current.dataKeys[index].push('');
      this.current.dataValues[index].push({ operator: '==', value: '0' });
    },
    removeData(index, dataIndex) {
      this.current.dataKeys[index].splice(dataIndex, 1);
      this.current.dataValues[index].splice(dataIndex, 1);
    },
    applyFilter() {
      this.pagination.current = 1;
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
